// CourseWriting.jsx
import React, { useEffect, useMemo, useState } from "react";
import "./CourseWriting.css";
import logo from "./bluelogo.png";
// videos
import WritingVideo1 from "./CourseContainer/Writing/linking words addition and concession.mp4";
import WritingVideo14 from "./CourseContainer/Grammar/Reported speech part 1(1080P_HD).mp4";
import WritingVideo15 from "./CourseContainer/Grammar/Reported speech part2(1080P_HD).mp4";
import WritingVideo16 from "./CourseContainer/Grammar/Reported speech part 3(1080P_HD).mp4";
import WritingVideo2 from "./CourseContainer/Writing/cause and effect.mp4";
import WritingVideo3 from "./CourseContainer/Grammar/modal verbs part2(1080P_HD).mp4";
import WritingVideo4 from "./CourseContainer/Grammar/أبسط شرح على اليوتيب _Modal verbs in English part 3(1080P_HD).mp4";
import WritingVideo5 from "./CourseContainer/Grammar/simple modals exercises 2025(1080P_HD).mp4";
import WritingVideo6 from "./CourseContainer/Writing/descriptive paragraph 2025.mp4";
import WritingVideo12 from "./CourseContainer/Grammar/Expressing purpose without mistakes(1080P_HD) (1).mp4";
import WritingVideo13 from "./CourseContainer/Grammar/Expressing purpose Exercises without mistakes(1080P_HD) (1).mp4";
import WritingVideo8 from "./CourseContainer/Grammar/Passive voice(1080P_HD).mp4";
import WritingVideo10 from "./CourseContainer/Grammar/wish and if only(1080P_HD).mp4";
import WritingVideo7 from "./CourseContainer/Grammar/relative pronouns 2026 PROOOOO(1080P_HD).mp4";
import WritingVideo9 from "./CourseContainer/Grammar/conditional type 3(1080P_HD).mp4";
import WritingVideo11 from "./CourseContainer/Grammar/Expressing regret(1080P_HD).mp4";
import WritingVideo17 from "./CourseContainer/Grammar/Prefixes and suffixes(1080P_HD).mp4";
import WritingVideo18 from "./CourseContainer/Grammar/phrasal verbs 2026 pro(1080P_HD).mp4";

import WritingIntro from "./CourseContainer/Writing/introduction to writing.mp4";

// pdfs
// import WritingVideo1Pdf from "./CourseContainer/pdfs/Writing/gerund and infinitive.pdf";
// import WritingVideo5Pdf from "./CourseContainer/pdfs/Writing/simple modals.pdf";
import WritingVideo6Pdf from "./CourseContainer/pdfs/Writing/Descriptive paragraph+ exercises.pdf";
// import WritingVideo13Pdf from "./CourseContainer/pdfs/Writing/Expresing purpose.pdf";
// import WritingVideo8Pdf from "./CourseContainer/pdfs/Writing/passive voice.pdf";
// import WritingVideo10Pdf from "./CourseContainer/pdfs/Writing/wish and if only.pdf";
// import WritingVideo7Pdf from "./CourseContainer/pdfs/Writing/relative pronouns.pdf";
// import WritingVideo9Pdf from "./CourseContainer/pdfs/Writing/conditionals.pdf";
// import WritingVideo12Pdf from "./CourseContainer/pdfs/Writing/Prefixes and suffixes.pdf";
// import WritingVideo14Pdf from "./CourseContainer/pdfs/Writing/phrasal verbs.pdf";

// import WritingVideo11Pdf from "./CourseContainer/pdfs/Writing/reported speech.pdf";

import Footer from "./Footer";
import Header from "./Header";

export default function CourseWriting() {
  // const tabs = ["Gerund & Infinitive", "Modal Verbs", "Passive Voice", ">>>"];
  const [activeTab, setActiveTab] = useState("Exams");
  const [query, setQuery] = useState("");

  // which accordion cards are open
  const [openIds, setOpenIds] = useState(() => new Set());

  // only one inline video open at a time
  const [openInlineVideo, setOpenInlineVideo] = useState(null); // { lessonId, itemId, videoSrc, title, subtitle }

  const lessons = useMemo(
    () => [
      {
        id: "introduction-to-Writing",
        title: "Introduction",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "wgintro-p1",
            label: "Click Play >>",
            duration: "03:51 min",
            videoSrc: WritingIntro,
          },
        ],
      },
      {
        id: "LinkingWords",
        title: "Linking Words",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "wgerund1-p1",
            label: "Addition + Concession",
            duration: "13:58 min",
            videoSrc: WritingVideo1,
          },
          
          {
            id: "wgerund1-p3",
            label: "Cause and Effect",
            duration: "07:52 min",
            videoSrc: WritingVideo2,
          },

          {
            id: "wgps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            // pdfSrc: WritingVideo1Pdf,
          },
        ],
      },
      {
        id: "ParagraphWriting",
        title: "Paragraph Writing",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gad-p1",
            label: "Part 1",
            duration: "12:41 min",
            videoSrc: WritingVideo2,
          },

          {
            id: "wgps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            // pdfSrc: WritingVideo5Pdf,
          },
        ],
      },
      {
        id: "DescriptiveParagraph",
        title: "Descriptive Paragraph",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "wgaa-p1",
            label: "Lesson",
            duration: "12:41 min",
            videoSrc: WritingVideo6,
          },

          {
            id: "wgps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: WritingVideo6Pdf,
          },
        ],
      },
      {
        id: "InformalEmail",
        title: "Informal Email",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "wugac-p1",
            label: "Part 1",
            duration: "12:41 min",
            videoSrc: WritingVideo7,
          },
          {
            id: "wgac-p1",
            label: "Part 2",
            duration: "12:41 min",
            videoSrc: WritingVideo7,
          },

          {
            id: "wgps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            // pdfSrc: WritingVideo7Pdf,
          },
        ],
      },
      {
        id: "FormalEmail",
        title: "Formal Email",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "wgco-p1",
            label: "Lesson",
            duration: "12:41 min",
            videoSrc: WritingVideo8,
          },

          {
            id: "wgps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            // pdfSrc: WritingVideo8Pdf,
          },
        ],
      },
      {
        id: "Formal-and-Informal-Letter",
        title: "Formal and Informal Letter",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "wguec-p1",
            label: "Lesson",
            duration: "12:41 min",
            videoSrc: WritingVideo9,
          },

          {
            id: "wgups-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            // pdfSrc: WritingVideo9Pdf,
          },
        ],
      },
      {
        id: "book-review",
        title: "A Book Review",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "wguar-p1",
            label: "Lesson",
            duration: "12:41 min",
            videoSrc: WritingVideo10,
          },

          {
            id: "wyups-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            // pdfSrc: WritingVideo10Pdf,
          },
        ],
      },
      {
        id: "film-review",
        title: "A Film Review",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "wwgymr-p1",
            label: "Lesson",
            duration: "12:41 min",
            videoSrc: WritingVideo11,
          },

          {
            id: "wrgyps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            // pdfSrc: WritingVideo11Pdf,
          },
        ],
      },
      {
        id: "writing-report",
        title: "Writing A Report",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "wgumsu-p1",
            label: "Lesson",
            duration: "12:41 min",
            videoSrc: WritingVideo12,
          },

          {
            id: "weygps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            // pdfSrc: WritingVideo13Pdf,
          },
        ],
      },
      {
        id: "Article",
        title: "Article",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "oigres-p1",
            label: "Advantages and Disadvantages",
            duration: "12:41 min",
            videoSrc: WritingVideo14,
          },
          {
            id: "tygres-p2",
            label: "Cause and Effect",
            duration: "12:41 min",
            videoSrc: WritingVideo15,
          },
          {
            id: "uygres-p2",
            label: "Causes, Consequences and Solutions",
            duration: "12:41 min",
            videoSrc: WritingVideo15,
          },

          {
            id: "ijops-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            // pdfSrc: WritingVideo11Pdf,
          },
        ],
      },
      {
        id: "Argumentative-paragraph",
        title: "Argumentative Paragraph",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "uygted-p1",
            label: "Lesson",
            duration: "12:41 min",
            videoSrc: WritingVideo17,
          },

          {
            id: "oops-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            // pdfSrc: WritingVideo12Pdf,
          },
        ],
      },
    ],
    []
  );

  const filteredLessons = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return lessons;
    return lessons.filter((l) =>
      `${l.title} ${l.subtitle}`.toLowerCase().includes(q)
    );
  }, [lessons, query]);

  const toggleAccordion = (lessonId) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(lessonId)) next.delete(lessonId);
      else next.add(lessonId);
      return next;
    });
  };

  const toggleInlineVideo = ({
    lessonId,
    itemId,
    videoSrc,
    title,
    subtitle,
  }) => {
    setOpenInlineVideo((curr) => {
      if (curr && curr.lessonId === lessonId && curr.itemId === itemId)
        return null;
      return { lessonId, itemId, videoSrc, title, subtitle };
    });
  };

  // icons defined INSIDE this file (simple)
  const IconPlay = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#4b5563" />
    </svg>
  );

  const IconPlaySmall = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#6b7280" />
    </svg>
  );

  const IconChevronDown = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M7 10l5 5 5-5H7Z" fill="#6b7280" />
    </svg>
  );

  const IconCheck = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M9.2 16.2 5.5 12.5 4.1 13.9l5.1 5.1L20 8.2 18.6 6.8 9.2 16.2Z"
        fill="#16a34a"
      />
    </svg>
  );
  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, []);

  window.onscroll = function () {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");

    if (window.scrollY > 50) {
      headerLogo.style.width = "60px";

      header.style.transition = "background 0.3s ease-in-out";
    } else {
      if (window.innerWidth < "668") {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      } else {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      }
    }
  };
  useEffect(() => {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");
    headerLogo.style.width = "60px";
    header.style.background = "white";
  }, []);
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <div className="WritingContainer">
      <header id="All__courses__header">
        <a href="https://toustousacademy.com/">
          <img className="Writing__header__img" src={logo} alt="" />
        </a>
        <ul>
          <a href="/" onClick={scrollToTop}>
            <li>Home</li>
          </a>
          <a href="/#about">
            <li>About</li>
          </a>
          <a href="/#feedback">
            <li>Feedback</li>
          </a>
        </ul>
      </header>
      <div className="tp-page">
        <div className="tp-container">
          <header className="tp-header">
            <h1 className="tp-title">Writing</h1>
            <p className="tp-subtitle">
              Short lessons + practice + correction.
            </p>
          </header>

          <div className="tp-toolbar">
            {/* <div className="tp-tabs">
              {tabs.map((t) => (
                <button
                  key={t}
                  className={`tp-tab ${activeTab === t ? "is-active" : ""}`}
                  onClick={() => setActiveTab(t)}
                  type="button"
                >
                  <span>{t}</span>
                  {t === "Exams" || t === "Future"}
                </button>
              ))}
            </div> */}
          </div>

          <main className="tp-list">
            {filteredLessons.map((lesson) => {
              const isOpen = openIds.has(lesson.id);

              return (
                <article key={lesson.id} className="tp-card">
                  {/* Accordion header */}
                  <button
                    className="tp-accHeader"
                    type="button"
                    onClick={() => toggleAccordion(lesson.id)}
                  >
                    <div className="tp-accLeft">
                      <div className="tp-playCircle" aria-hidden="true">
                        <IconPlay />
                      </div>

                      <div className="tp-cardMain">
                        <div className="tp-cardTitle">{lesson.title}</div>
                        <div className="tp-cardSub">{lesson.subtitle}</div>

                        {lesson.meta && (
                          <div className="tp-pills">
                            {lesson.meta.map((m) => (
                              <span key={m} className="tp-pill">
                                {m}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <span className={`tp-accChev ${isOpen ? "is-open" : ""}`}>
                      <IconChevronDown />
                    </span>
                  </button>

                  {/* Accordion body */}
                  <div className={`tp-accBody ${isOpen ? "is-open" : ""}`}>
                    {lesson.items.map((it) => {
                      const isExercise = it.kind === "exercise";
                      const isThisVideoOpen =
                        openInlineVideo?.lessonId === lesson.id &&
                        openInlineVideo?.itemId === it.id;

                      return (
                        <div key={it.id} className="tp-itemBlock">
                          <div
                            className={`tp-itemRow ${
                              isExercise ? "is-exercise" : ""
                            }`}
                          >
                            <div className="tp-itemLeft">
                              <div
                                className={
                                  isExercise
                                    ? "tp-checkCircle"
                                    : "tp-smallPlayCircle"
                                }
                                aria-hidden="true"
                              >
                                {isExercise ? <IconCheck /> : <IconPlaySmall />}
                              </div>
                              <div className="tp-itemTitle">{it.label}</div>
                            </div>

                            <div className="tp-itemRight">
                              <div className="tp-partDur">
                                {it.duration || ""}
                              </div>

                              {isExercise ? (
                                <a
                                  className="tp-playBtn tp-playBtnLight"
                                  href={it.pdfSrc}
                                  download
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Download PDF
                                  {/* <span className="tp-playBtnChev">›</span> */}
                                </a>
                              ) : (
                                <button
                                  className="tp-playBtn"
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleInlineVideo({
                                      lessonId: lesson.id,
                                      itemId: it.id,
                                      videoSrc: it.videoSrc,
                                      title:
                                        it.label === "Click Play >>"
                                          ? lesson.title
                                          : `${lesson.title} — ${it.label}`,
                                      subtitle: lesson.subtitle,
                                    });
                                  }}
                                >
                                  {isThisVideoOpen ? "Hide" : "Play"}{" "}
                                  <span className="tp-playBtnChev">›</span>
                                </button>
                              )}
                            </div>
                          </div>

                          {/* inline video under the row */}
                          {isThisVideoOpen && (
                            <div className="tp-inlineVideoWrap">
                              <div className="tp-inlineVideoHeader">
                                <div className="tp-inlineVideoTitle">
                                  {openInlineVideo.title}
                                </div>
                                <div className="tp-inlineVideoSub">
                                  {openInlineVideo.subtitle}
                                </div>
                              </div>

                              <video
                                key={openInlineVideo.videoSrc}
                                className="tp-inlineVideo"
                                controlsList="nodownload noplaybackrate"
                                disablePictureInPicture
                                onContextMenu={(e) => e.preventDefault()}
                                controls
                                autoPlay
                                src={openInlineVideo.videoSrc}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </article>
              );
            })}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
